export const service_url = process.env.API_URL || process.env.VUE_APP_API_URL;
